import { Link } from "react-router-dom";

const columns = [
  {
    title: "内容导航",
    links: [
      { label: "影视资讯", to: "/news/影视资讯" },
      { label: "游戏动态", to: "/news/游戏动态" },
      { label: "漫画观察", to: "/news/漫画观察" },
      { label: "行业观察", to: "/news/行业观察" },
    ],
  },
  {
    title: "资源分类",
    links: [
      { label: "影视资源", to: "/resources/film" },
      { label: "游戏资源", to: "/resources/game" },
      { label: "漫画资源", to: "/resources/comic" },
      { label: "话题讨论", to: "/topics" },
    ],
  },
  {
    title: "关于本站",
    links: [
      { label: "网站介绍", to: "/about" },
      { label: "内容声明", to: "/about" },
      { label: "联系我们", to: "/contact" },
      { label: "隐私说明", to: "/about" },
    ],
  },
];

const socials = [
  { icon: "ri-wechat-line", label: "微信" },
  { icon: "ri-weibo-line", label: "微博" },
  { icon: "ri-telegram-line", label: "Telegram" },
  { icon: "ri-mail-line", label: "邮件" },
];

export default function SiteFooter() {
  return (
    <footer className="mt-20 bg-primary-900 text-background-100">
      <div className="mx-auto max-w-[1280px] px-4 py-14 md:px-6">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 flex-col items-center justify-center rounded-md bg-background-50 text-primary-800">
                <span className="font-heading text-[15px] font-bold leading-none">18</span>
                <span className="mt-0.5 text-[9px] leading-none tracking-[0.12em]">禁</span>
              </span>
              <div>
                <div className="font-heading text-base font-semibold tracking-[0.06em]">18禁</div>
                <div className="text-[9px] tracking-[0.18em] text-primary-200">ADULT ARCHIVE</div>
              </div>
            </div>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-background-200/90">
              面向成年观众的成人内容资讯与资源整理平台，覆盖影视、游戏、漫画三大领域。我们更在意信息的准确与阅读的舒适。
            </p>
            <div className="mt-6 flex items-center gap-3">
              {socials.map((item) => (
                <button
                  key={item.label}
                  type="button"
                  aria-label={item.label}
                  className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full border border-background-50/20 text-background-100 transition hover:border-accent-400 hover:text-accent-300"
                >
                  <i className={`${item.icon} text-base`} aria-hidden="true"></i>
                </button>
              ))}
            </div>
          </div>

          {columns.map((column) => (
            <div key={column.title}>
              <h4 className="mb-4 text-[11px] font-medium tracking-[0.18em] text-accent-300">{column.title}</h4>
              <ul className="space-y-3">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="cursor-pointer text-sm text-background-200/90 transition hover:text-background-50"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-background-50/15 pt-6 text-xs text-background-200/70 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 18禁 ADULT ARCHIVE. 本站内容均为虚构演示，不提供任何真实资源下载。</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <span>内容分级：18+</span>
            <span>备案号：演示备案 000000000</span>
            <span>仅限成年人访问</span>
          </p>
        </div>
      </div>
    </footer>
  );
}